import { TabNames } from "constant/tabNames";

const Tabs: string[] = [TabNames.Episodes, TabNames.Info];

function TVSeriesTabs({ selectedTab, setSelectedTab }: any) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-1 backdrop-blur-md">
      {Tabs.map((tab: string, i: number) => (
        <p
          className={`cursor-pointer rounded-full px-4 py-1.5 text-[13px] font-semibold transition-colors duration-200 ${
            selectedTab === tab
              ? "bg-[#F50537] text-white shadow-[0_4px_14px_rgba(245,5,55,0.35)]"
              : "text-white/60 hover:text-white"
          }`}
          key={i}
          onClick={() => setSelectedTab(tab)}
        >
          {tab}
        </p>
      ))}
    </div>
  );
}

export default TVSeriesTabs;
